import React from "react";
import { getOrderStatusColor, makeCamelCase } from "../utils/Common";
import { constants } from "../constant/constants";
import { useNavigate } from "react-router-dom";
import CustomTooltip from "../utils/CustomTooltip";
import { navToPayment } from "../services/order-common-service";

function OrderComponent({
  record,
  callback,
  isTableManagement,
  index = 0,
  optimized = false,
  newOrderId = "",
  sourcePage = "ORDER_LIST",
  shouldLockRow = "",
}) {
  const navigate = useNavigate();
  let color = getOrderStatusColor(record?.status || '');
  let dot = { background: color };
  let dotText = { color };

  const acceptOrder = () => {
    if (isTableManagement) {
      const takeout = record.orderType === 'Dine-in' ? 'No' : 'Yes';
      navToPayment(navigate, record.orderId, sourcePage, takeout, record.paginationPageNo);
      return;
    }
    callback(record, constants.ORDER.ACCEPT);
  };
  const receivePayment = () => {
    const takeout = record.orderType === "Takeout" ? "Yes" : "No";

    if (isTableManagement) {
      navToPayment(navigate, record.orderId, sourcePage, takeout, record.paginationPageNo)
      return;
    }

    callback(record, constants.ORDER.PAID);
  };

  const refundOrder = () => {
    callback(record, constants.ORDER.REFUND);
  };

  const editOrder = () => {
    const takeout = record.orderType === "Takeout" ? "Yes" : "No";
    const tableManagement = isTableManagement ? "Active" : "Inactive";
    navigate(
      `/order/${record.orderId}/edit?tablemanagement=${tableManagement}&takeout=${takeout}&sourcePage=${sourcePage}&pageNo=${record.paginationPageNo}&paymentStatus=${record.paid}`
    );
  };
  const viewOrder = (e) => {
    // callback(record, constants.ORDER.VIEW);
    e.preventDefault();
    navigate(`/order/${record.orderId}/details?pageNo=${record.paginationPageNo}&sourcePage=${sourcePage}`);
  };

  const displayInvoice = () => {
    callback(record, constants.ORDER.INVOICE);
  };
  const paidStyle = {
    color: record.paid != 1 ? "#EE3169" : "#2EC12B",
  };

  return (
    <div
      key={`OrderComponent${index}`}
      className={`relative flex flex-row  cursor-pointer mb-[16px] font-uregular p-[16px] rounded  w-full items-center 
        ${
          newOrderId === record.orderId
            ? "animate-blink bg-orange"
            : shouldLockRow === record.orderId
            ? "bg-gray-200"
            : "bg-white"
        }
      `}
      onClick={shouldLockRow === record.orderId ? undefined : viewOrder}
    >
      <div className="w-[20%] flex flex-col items-start justify-center mx-[8px] xl:w-[200px] 2xl:w-[250px]">
        <div className="text-sm text-pregray font-ubold w-full]">{`Order # ${record.orderNumber}`}</div>
        <div className="text-sm text-[#f39c12] font-ubold w-full]">{`Table # ${record.tableNumber || "____"}`}</div>
        <div className="text-xs text-pregray">{record.date}</div>
      </div>
      <div className="w-[25%] flex flex-col mx-[16px] flex-grow">
        <div className="flex flex-row items-center">
          <img
            className="w-[12px] h-[12px]"
            src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/phone.svg"}
          />
          <div className="text-md text-pregray font-uregular ml-[8px]">+{record.number}</div>
        </div>
        <div className="flex flex-row items-center">
          <img
            className="w-[12px] h-[12px]"
            src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/creditcard.svg"}
          />

          <div style={paidStyle} className="text-sm text-pregray font-ubold ml-[8px]">
            {`${record.total.toFixed(2)} TK (${record.paymentStatusText})`}
          </div>

          {/* start refund or due amount */}
          {record?.refundInfo && !record.refundInfo?.isRefunded && (
            <div className="text-sm font-ubold ml-[8px] text-red-600">
              {`(Refund: ${record.refundInfo.totalRefundAmount.toFixed(2)} TK)`}
            </div>
          )}
          {/* start refund or due amount */}
        </div>
      </div>

      {!optimized && (
        <div className="w-[25%] flex flex-col mx-[16px] flex-grow">
          <div className="flex flex-row items-center">
            <strong className="text-sm text-pregray font-uregular w-[110px]">Total food Items</strong>
            <div className="text-sm text-pregray font-uregular ml-[8px]">: {record.totalFoodItems}</div>
          </div>
          {record.delivery_time && (
            <div className="flex flex-row items-center">
              <strong className="text-sm text-pregray font-uregular w-[110px]">Delivery Time</strong>
              <div className="text-sm text-pregray font-uregular ml-[8px]">: {record.delivery_time}</div>
            </div>
          )}

          {record.comment && (
            <div className="flex flex-row items-center text-gray-400">
              <div className="w-[110px] text-xs font-uregular">Special Instruction</div>
              <div className="w-[110px] text-sm  font-uregular ml-[8px] truncate whitespace-nowrap overflow-hidden text-ellipsis">
                :{" "}
                <CustomTooltip placement="bottomLeft" title={record.comment}>
                  {record.comment}
                </CustomTooltip>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="w-[15%] flex flex-col mx-[4px] xl:w-[200px] 2xl:w-[200px]">
        <div className="flex flex-row items-center">
          {/* {record.orderType} */}
          <CustomTooltip placement="bottom" title={record.orderType}>
            <img
              onClick={(e) => {
                // e.stopPropagation();
                // editOrder();
              }}
              className="w-[30px] h-[30px]"
              src={
                record.orderType === "Takeout"
                  ? "https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/takeout.svg"
                  : "https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/dining.svg"
              }
            />
          </CustomTooltip>
        </div>
      </div>

      <div className="w-[15%] flex flex-col mx-[4px] xl:w-[200px] 2xl:w-[200px]">
        <div className="flex flex-row items-center">
          <div style={dot} className="w-[12px] h-[12px] rounded-[6px]" />
          <div style={dotText} className="text-md ml-[8px]">
            {makeCamelCase(record.status)}
          </div>
        </div>
      </div>

      <div className="w-[15%] flex flex-row items-center px-[8px] w-[156px]">
        {record.status === "cancelled" ? (
          // Only which need to refund
          <>
            {record?.refundInfo && !record.refundInfo?.isRefunded && (
              <CustomTooltip placement="bottom" title="Refund Order Payment">
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    refundOrder();
                  }}
                  className="w-[30px] h-[30px]"
                  src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/refund-icon.svg"}
                />
              </CustomTooltip>
            )}
          </>
        ) : (
          <>
            {record.status !== "completed" && (
              <CustomTooltip placement="bottom" title="Edit Order">
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    editOrder();
                  }}
                  className="w-[30px] h-[30px]"
                  src={
                    "https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/edit_user_icon.svg"
                  }
                />
              </CustomTooltip>
            )}

            {record.status !== "pending" && record.paid == 0 && (
              <CustomTooltip placement="bottom" title="Recieve Payment">
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    receivePayment();
                  }}
                  className="ml-[3px] w-[32px] h-[32px]"
                  src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/dollaricon.svg"}
                />
              </CustomTooltip>
            )}

            {record.status === "pending" ? (
              <>
                <CustomTooltip placement="bottom" title="Accept Order">
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      acceptOrder();
                    }}
                    className="w-[36px] h-[36px]"
                    src={"/images/tickicon.svg"}
                  />
                </CustomTooltip>
              </>
            ) : (
              <></>
            )}
            {record.status !== "pending" && (
              <CustomTooltip placement="bottom" title="Invoice">
                <img
                  onClick={(e) => {
                    e.stopPropagation();
                    displayInvoice();
                  }}
                  className="w-[36px] p-[2px] h-[36px]"
                  src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/invoice_icon.svg"}
                />
              </CustomTooltip>
            )}
          </>
        )}
      </div>
      {shouldLockRow === record.orderId && <div className="absolute inset-0 bg-transparent z-50 cursor-not-allowed" />}
    </div>
  );
}

export default OrderComponent;
